var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticStyle: { "min-height": "450px" } }, [
    !_vm.hasScale
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.value,
              expression: "value",
              modifiers: { number: true },
            },
          ],
          staticClass: "form-control",
          attrs: { type: "number" },
          domProps: { value: _vm.value },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.value = _vm._n($event.target.value)
            },
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.hasScale
      ? _c(
          "div",
          { staticClass: "list-group" },
          _vm._l(_vm.scaleLevels, function (sl) {
            return _c(
              "a",
              {
                staticClass:
                  "list-group-item list-group-item-action text-center",
                class: {
                  "bg-success": _vm.value === sl.Value,
                  "bg-white": _vm.value !== sl.Value,
                },
                on: {
                  click: function ($event) {
                    _vm.value = sl.Value
                  },
                },
              },
              [
                _c("strong", [
                  _vm._v(_vm._s(sl.Value) + " - " + _vm._s(sl.Name)),
                ]),
                _vm._v(" "),
                sl.Definition
                  ? _c("p", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(sl.Definition)),
                    ])
                  : _vm._e(),
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "text-center" }, [
      _c(
        "button",
        {
          staticClass: "btn mt-3",
          class: _vm.value == null ? "btn-success" : "btn-outline-secondary",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              _vm.value = null
            },
          },
        },
        [
          _c("i", {
            staticClass: "fa-regular",
            class: _vm.value == null ? "fa-square-check" : "fa-square",
          }),
          _vm._v("\n            Follow the average (default)\n        "),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _c("div", { staticStyle: { "margin-top": "15px" } }, [
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model.trim",
            value: _vm.comment,
            expression: "comment",
            modifiers: { trim: true },
          },
        ],
        staticClass: "form-control",
        attrs: { rows: "5", placeholder: "Comment..." },
        domProps: { value: _vm.comment },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.comment = $event.target.value.trim()
          },
          blur: function ($event) {
            return _vm.$forceUpdate()
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }